import React, { Fragment, useLayoutEffect, useState } from "react";
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from "reactstrap";
import { ChromePicker } from 'react-color';
import classnames from "classnames";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import { NotificationManager } from "../../../../../../components/common/react-notifications";
import { API_CopyTemplate_Integration } from "../../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../../helpers/AxiosAPI";
import { setBackGroundColor } from '../../../integration/style/DigitalAssistantStyle';
import sync_template from '../../../../../../assets/template_to_bot.png';
const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;
export default function Templates({ propertyId }) {
    const [apiTemplate, setApiTemplate] = useState("default");
    const [templateData, setTemplateData] = useState({
        fromGroupId: fromGroupId,
        fromPropertyId: fromPropertyId,
        toPropertyId: propertyId,
        toGroupId: getGroupID(),
        isForm: true,
        isHelpItem: true,
        isWeb: true,
        isMessengerX: true,
        isAssistantMenu: true,
        isFAQ: true,
        appearance: null
    });
    const [appearanceData, setAppearanceData] = useState({ primaryColor: "#424344", staticColor: "#000", contrastColor: "white" });
    let [iseditMode, setEditMode] = useState({ primaryColor: false, staticColor: false, });
    const [edit, setEdit] = useState(true);
    const [error, setError] = useState(true);
    const handleSubmit = () => {
        setApiTemplate('processing');
        templateData.appearance = appearanceData;
        if (templateData.fromPropertyId !== undefined && templateData.toPropertyId !== undefined) {
            AxiosAPI({
                method: 'post',
                url: `${API_CopyTemplate_Integration}`,
                data: templateData,
            }).then((res) => {
                setApiTemplate('success');
                NotificationManager.success(
                    '',
                    'Template copy successfully done!!',
                    3000,
                    null,
                    null,
                    'success'
                );
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }, (error) => {
                setApiTemplate('fail');
                NotificationManager.error(
                    '',
                    'Something went wrong.',
                    3000,
                    null,
                    null,
                    'error'
                );
                console.log('eee.data', error.data);
            }
            );
        }
        else {
            setApiTemplate('fail');
        }
    }
    return (
        <Fragment>
            <Row className="mt-3 mb-2">
                <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
                    <CardBody>
                        <Colxx md="12" className="mt-2 mb-3">
                            <img
                                src={sync_template}
                            // style={{ width: '100%', height: '90px' }}
                            ></img>
                        </Colxx>
                        <Colxx sm={12} className="mb-2">
                            <p className="mb-2">To have a Digital Assistant working at its full potential, you will need the following:</p>
                            <ul className="ml-4">
                                <li>Common help items guests look for</li>
                                <li>Forms with built-in automation</li>
                                <li>AI Chatbot for your website</li>
                                <li>Web Widget for your website</li>
                            </ul>
                            <p className="mb-2 mt-2">Save time by letting Sprint build these for you. You can later change or customize every aspect you like.</p>
                        </Colxx>
                        <Colxx sm={12} className="mb-2">
                            <Label>Select your primary website/brand colors.</Label>
                            <Row>
                                <Colxx md={4}>
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                                                <span className=''>Primary Color​</span>
                                            </div>
                                            <div className='col-md-12'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            setAppearanceData({ ...appearanceData, primaryColor: e.target.value });
                                                        }}
                                                        value={appearanceData.primaryColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                                        }}
                                                            className="color-square" style={setBackGroundColor(appearanceData.primaryColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.primaryColor && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-2'
                                                style={{ width: '200px' }}
                                                color={appearanceData.primaryColor}
                                                onChangeComplete={(e) => {
                                                    if (edit) {
                                                        setAppearanceData({ ...appearanceData, primaryColor: e.hex });
                                                        setEditMode({ ...iseditMode, primaryColor: false });
                                                    } else setError(true);
                                                }}
                                            />
                                        </div>
                                    </div>}
                                </Colxx>
                                {/* <Colxx sm={4}>
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                                                <span className=''>Static Color</span>
                                            </div>
                                            <div className='col-md-12'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            setAppearanceData({ ...appearanceData, staticColor: e.target.value });
                                                        }}
                                                        value={appearanceData.staticColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, staticColor: !iseditMode.staticColor });
                                                        }}
                                                            className="color-square" style={setBackGroundColor(appearanceData.staticColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.staticColor && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-2'
                                                style={{ width: '200px' }}
                                                color={appearanceData.staticColor}
                                                onChangeComplete={(e) => {
                                                    if (edit) {
                                                        setAppearanceData({ ...appearanceData, staticColor: e.hex });
                                                        setEditMode({ ...iseditMode, staticColor: false });
                                                    } else setError(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    }
                                </Colxx> */}
                                <Colxx sm={4}>
                                    <Label>Contrast Text Color</Label>
                                    <div className="d-flex">
                                        <CustomInput
                                            type="radio"
                                            id="white"
                                            value={"white"}
                                            onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                                            checked={appearanceData.contrastColor === "white" ? true : false}
                                        >White</CustomInput>
                                        <CustomInput
                                            className="ml-2"
                                            type="radio"
                                            id="black"
                                            value={"black"}
                                            onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                                            checked={appearanceData.contrastColor === "black" ? true : false}
                                        >Black</CustomInput>
                                    </div>
                                </Colxx>
                            </Row>
                        </Colxx>
                        <Colxx sm={12} className="mb-2">
                            <Label>Select the templetes you want to copy</Label>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    id="isHelpItem"
                                    onChange={(e) => setTemplateData({ ...templateData, isHelpItem: e.target.checked })}
                                    checked={templateData.isHelpItem}
                                >Common help items</CustomInput>
                            </FormGroup>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    id="isForm"
                                    onChange={(e) => setTemplateData({ ...templateData, isForm: e.target.checked })}
                                    checked={templateData.isForm}
                                >Common Forms</CustomInput>
                            </FormGroup>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    name="isWeb"
                                    id="isWeb"
                                    onChange={(e) => setTemplateData({ ...templateData, isWeb: e.target.checked })}
                                    checked={templateData.isWeb}
                                >Chatbot for website</CustomInput>
                            </FormGroup>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    name="isMessengerX"
                                    id="isMessengerX"
                                    onChange={(e) => setTemplateData({ ...templateData, isMessengerX: e.target.checked })}
                                    checked={templateData.isMessengerX}
                                >Web Widget for website</CustomInput>
                            </FormGroup>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    name="isAssistantMenu"
                                    id="isAssistantMenu"
                                    onChange={(e) => setTemplateData({ ...templateData, isAssistantMenu: e.target.checked })}
                                    checked={templateData.isAssistantMenu}
                                >Default welcome message
                                    {/* Assistant Menu */}
                                </CustomInput>
                            </FormGroup>
                            <FormGroup>
                                <CustomInput
                                    type="checkbox"
                                    name="isFAQ"
                                    id="isFAQ"
                                    onChange={(e) => setTemplateData({ ...templateData, isFAQ: e.target.checked })}
                                    checked={templateData.isFAQ}
                                > FAQ’s
                                </CustomInput>
                            </FormGroup>
                        </Colxx>
                        <Colxx sm={12}>
                            <Button color="primary" onClick={handleSubmit}
                                className={`btn-multiple-state ${classnames(
                                    {
                                        "show-spinner": apiTemplate === "processing",
                                        "show-success": apiTemplate === "success",
                                        "show-fail": apiTemplate === "fail"
                                    }
                                )}`}
                            >
                                <span className="spinner d-inline-block">
                                    <span className="bounce1" />
                                    <span className="bounce2" />
                                    <span className="bounce3" />
                                </span>
                                <span className="icon success">
                                    <i className="simple-icon-check" />
                                </span>
                                <span className="icon fail">
                                    <i className="simple-icon-exclamation" />
                                </span>
                                <span className="label">Import</span>
                            </Button>
                        </Colxx>
                    </CardBody>
                </Card>
            </Row>
        </Fragment>);
}